const indexItems = [
  { letter: 'A', title: '娱乐圈爆料', count: 2340, desc: '明星恋情、婚变、合约纠纷等娱乐圈一手资讯' },
  { letter: 'B', title: '网红翻车实录', count: 1876, desc: '直播事故、人设崩塌、税务问题等网红圈内幕' },
  { letter: 'C', title: '综艺节目黑幕', count: 1560, desc: '选秀造假、剧本泄露、节目组与嘉宾冲突等' },
  { letter: 'D', title: '影视行业潜规则', count: 1432, desc: '带资进组、阴阳合同、片酬争议等行业内幕' },
  { letter: 'E', title: '企业黑料曝光', count: 1280, desc: '上市公司丑闻、产品质量问题、劳资纠纷等' },
  { letter: 'F', title: '社会热点追踪', count: 1156, desc: '公共事件、民生问题、社会不公等热点报道' },
  { letter: 'G', title: '科技圈内幕', count: 987, desc: '产品泄密、数据造假、科技公司人事变动等' },
  { letter: 'H', title: '财经大事件', count: 865, desc: '股市异动、金融骗局、资本运作等财经资讯' },
  { letter: 'I', title: '体育圈风波', count: 734, desc: '赛事黑哨、球员转会内幕、体育界丑闻等' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-secondary-600 font-medium bg-secondary-50 px-3 py-1 rounded-full">主题索引</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">主题索引</h2>
          <p className="mt-2 text-sm text-foreground-500">按主题分类浏览，快速找到你感兴趣的内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, index) => (
            <a
              key={index}
              href="#updates"
              className="flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 transition-colors group cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg font-heading font-bold text-lg group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                {item.letter}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}条</span>
                </div>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-300 group-hover:text-primary-500 transition-colors">
                <i className="ri-arrow-right-s-line"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}